import initialState from "./initialState";
import {ADD_MESSAGES, REMOVE_MESSAGE} from "../actions/NotificationMessagesAction";

export default (state = initialState.notificationMessages, action) => {

    switch (action.type) {
        case ADD_MESSAGES:
            return [
                ...state,
                action.payload.data
            ];
        case REMOVE_MESSAGE:
            const key = action.payload.data.key;
            return state.filter( item => item.key === key );
        default:
            return state

    }
}
